<div class="go-tab__list">
  <div
    *ngFor="let tab of tabArray; let i = index"
    class="go-tab__header"
    [ngClass]="{ 'go-tab__header--active': tab.active, 'go-tab__header--dark': theme === 'dark' }"
    (click)="activateTab(i)"
  >
    {{ tab.heading }}
  </div>
</div>

<div class="go-tab__card-wrapper">
  <div
    class="go-tab__card"
    [ngClass]="{ 'go-tab__card--first-tab-active': activeTab === 0 || theme === 'dark', 'go-tab__card--dark': theme === 'dark' }"
  >
    <ng-content></ng-content>
  </div>
</div>
